import Vue from 'vue';
import './registerServiceWorker';

import 'vue-directive-tooltip/src/css/index.scss'; // Revisar si es necesario.
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import { abilitiesPlugin } from '@casl/vue';
import ability from '@/config/ability';

import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti);

// i18n
import i18n from '@/i18n/i18n';

// axios
import '@/httpConfig';

// filters
import '@/scripts/filters';

// Globally Registered Components
import '@/globalComponents';

// Vuex Store
import store from '@/store';

// Vue Router
import router from './router';

// permission control
import './permission';

// Directives
import '@/directives/main';

// Styles: css
import '../node_modules/font-awesome/css/font-awesome.css';
import '@/assets/fonts/comfortaa/specimen_files/specimen_stylesheet.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/fonts/comfortaa/stylesheet.css';
import '@/assets/fonts/futura/stylesheet.css';
import '@/assets/fonts/atma/stylesheet.css';
import '@/assets/fonts/Lato/stylesheet.css';
import '@/assets/fonts/Varela_Round/stylesheet.css';

Vue.use(abilitiesPlugin, ability);
window.ability = ability;

import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
